import { BellRing, BicepsFlexed, Bird, Bomb, CalendarDays, CarFront, Clapperboard, CloudHail, Cog, ConciergeBell, Drama, Droplet, FlaskConical, Gamepad2, Ghost, Keyboard, Lamp, Laugh, MapPin, Megaphone, Mic, MountainSnow, Music, Shell, Siren, Smartphone, Smile, Sword, Telescope, TreePine, Users, Volume2 } from '@music-vine/cadence/icons';
import { Balloon } from '../Icons/Balloon';
import { BoxingGlove } from '../Icons/BoxingGlove';
import { Scary } from '../Icons/Scary';
import { Wellbeing } from '../Icons/Wellbeing';
export const POPULAR_SFX_ICONS = [{
  id: 1,
  name: 'Nature',
  icon: TreePine
}, {
  id: 2,
  name: 'Animals',
  icon: Bird
}, {
  id: 3,
  name: 'Alarm',
  icon: Siren
}, {
  id: 4,
  name: 'Funny',
  icon: Laugh
}, {
  id: 5,
  name: 'Bells & whistles',
  icon: ConciergeBell
}, {
  id: 6,
  name: 'Beeps & buzzers',
  icon: Megaphone
}, {
  id: 7,
  name: 'Transport',
  icon: CarFront
}, {
  id: 8,
  name: 'Scary',
  icon: Scary
}, {
  id: 9,
  name: 'Weather',
  icon: CloudHail
}, {
  id: 10,
  name: 'Clicks & typing',
  icon: Keyboard
}, {
  id: 11,
  name: 'Fighting',
  icon: BoxingGlove
}, {
  id: 12,
  name: 'Weapon',
  icon: Sword
}, {
  id: 34,
  name: 'Wellbeing',
  icon: Wellbeing
}, {
  id: 13,
  name: 'Sci-fi & space',
  icon: Telescope
}, {
  id: 14,
  name: 'Domestic',
  icon: Lamp
}, {
  id: 15,
  name: 'Emotions',
  icon: Smile
}, {
  id: 16,
  name: 'Supernatural',
  icon: Ghost
}, {
  id: 17,
  name: 'Pops & dings',
  icon: Balloon
}, {
  id: 18,
  name: 'Video editing',
  icon: Clapperboard
}, {
  id: 19,
  name: 'Noises',
  icon: Volume2
}, {
  id: 20,
  name: 'Crowd',
  icon: Users
}, {
  id: 21,
  name: 'Occasions',
  icon: CalendarDays
}, {
  id: 22,
  name: 'Places',
  icon: MapPin
}, {
  id: 23,
  name: 'Body',
  icon: BicepsFlexed
}, {
  id: 24,
  name: 'Gaming & sports',
  icon: Gamepad2
}, {
  id: 25,
  name: 'Music clips',
  icon: Music
}, {
  id: 26,
  name: 'Voice clips',
  icon: Mic
}, {
  id: 27,
  name: 'Notification',
  icon: BellRing
}, {
  id: 28,
  name: 'Impacts',
  icon: Bomb
}, {
  id: 29,
  name: 'Mechanical',
  icon: Cog
}, {
  id: 30,
  name: 'Elements',
  icon: Droplet
}, {
  id: 31,
  name: 'Digital',
  icon: Smartphone
}, {
  id: 32,
  name: 'Technology & science',
  icon: FlaskConical
}, {
  id: 33,
  name: 'Other',
  icon: Shell
}, {
  id: 35,
  name: 'Moments & reactions',
  icon: Drama
}, {
  id: 36,
  name: 'Ambience & environments',
  icon: MountainSnow
}];